import React, { useState } from 'react';
import css from './OptOutInfo.scss';
import PropTypes from 'prop-types';
import { isEmptyString } from 'utils/text';
import { pressedEnterOrSpace } from 'utils/accessibility';
import HelpDeskInfoModal from 'helpPage/HelpDeskInfoModal';

const OptOutInfo = ({ cellPhone, textNotificationEnabledForUser, isStaff }) => {
    const [showOptedOutInfo, setShowOptedOutInfo] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);

    // if the user is opted in or doesn't have any number, we shouldn't display opt out information
    if (textNotificationEnabledForUser || isEmptyString(cellPhone)) return null;
    return (
        <div className={css['opted-out-info']}>
                <a className={css['show-info']}
                   href="#"
                   onClick={() => setShowOptedOutInfo(!showOptedOutInfo)}
                   onKeyDown={(e) => { if (pressedEnterOrSpace(e)) {
                       e.preventDefault();
                       setShowOptedOutInfo(!showOptedOutInfo);
                   }}}>
                    Not receiving texts?
                    { showOptedOutInfo && <> Hide tip</> }
                </a>
            { showOptedOutInfo &&
            <>
                <br/>
                {"Be sure the number is correct and can receive text messages. For technical support, "}
                <a className={css['show-info']}
                   aria-label='Click to contact your institution'
                   href="#"
                   onClick={() => setModalOpen(true)}
                   onKeyDown={(e) => {
                       if (pressedEnterOrSpace(e)) {
                           e.preventDefault();
                           setModalOpen(true);
                       }}}>
                    contact your institution.
                </a>
                <HelpDeskInfoModal isOpen={isModalOpen}
                                   onClose={() => setModalOpen(false)}
                                   showStarfishHelpLink={isStaff}
                                   allowRedirect={false}/>
            </>
            }
        </div>
    );
};

OptOutInfo.propTypes = {
    cellPhone: PropTypes.string,
    textNotificationEnabledForUser: PropTypes.bool,
    isStaff: PropTypes.bool
};

export default OptOutInfo;
